import { reactive } from 'vue'

const storeRegistry = new Map()

export function createPinia() {
  return {
    install() {
      // 轻量实现：当前项目只需要 defineStore 的单例能力
    }
  }
}

export function defineStore(id, setup) {
  return function useStore() {
    if (!storeRegistry.has(id)) {
      const rawStore = setup()
      const wrappedStore = reactive(rawStore)
      storeRegistry.set(id, wrappedStore)
    }
    return storeRegistry.get(id)
  }
}
